<div class="device" [ngClass]="{  
        'device--offline' : data.statusCode === statusTypes.offline, 
        'device--selected' : data.isSelected,
        'device--ready' : data.statusCode === statusTypes.idle,
        'device--printing': data.uploadId || data.statusCode !== statusTypes.idle
    }">
    <div class="device__image">
        <img class="image" [src]="'assets/device/'+data.picture" alt="device photo" />
        <nb-icon class="icon" icon="checkmark-outline" status="primary"></nb-icon>
    </div>

    <div class="device__body">
        <div class="body__name">
            {{data | serialNumberWithDeviceType}}
        </div>
        <ng-container *ngIf="uploadId && data.statusCode === statusTypes.idle">
            <div class="body__progress">
                <ng-container *ngIf="uploadingProgress$ | async;let uploading">
                    <nb-progress-bar [value]="uploading.progress" [status]="'primary'" size="small"
                        [displayValue]="true" [attr.current-value]="uploading.progress">
                    </nb-progress-bar>
                </ng-container>
            </div>
        </ng-container>
        <div class="body__materials">
            <div class="materials__item--name">
                {{'device.files.material' | translate}}:
            </div>
            <div class="materials__item--value" *ngFor="let material of data.materials; trackBy: trackByFn">
                {{material.name}}
                <span *ngIf="material !== data.materials[data.materials.length-1]" class="me-1">,</span>
            </div>
        </div>
        <div class="body__status">
            <span *ngIf="!uploadId">
                <app-device-status-name [deviceId]="data.id" [statusCode]="data.statusCode" [reason]="data.reason">
                </app-device-status-name>
            </span>
            <div *ngIf="uploadId && data.statusCode === statusTypes.idle">
                <ng-container *ngIf="uploadingProgress$ | async;let uploading;else progressStatus">
                    {{(uploading.errorCode === 0 ? multiPrintStatuses[multiPrintState.downloadingFile] :
                    multiPrintStatuses[multiPrintState.error]) | translate}}
                </ng-container>

                <ng-template #progressStatus>{{multiPrintStatuses[multiPrintState.downloadingFile] | translate}}
                </ng-template>
            </div>
        </div>
    </div>
</div>